/* eslint-disable */
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js';
import { CSSPlugin } from 'gsap/CSSPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(CSSPlugin);

CSSPlugin.useSVGTransformAttr = true;

let mm = gsap.matchMedia();

const animateFadeIn = (ele, options = {}, trigger) => {
  //initiate the defaul values
  const { delay = 0, duration = 0.5, stagger = 0.2, start = 'top 90%' } = options;

  if (!ele.length) return;

  //item appear
  gsap.utils.toArray(ele).forEach((item) => {
    gsap.fromTo(
      $(item).children(),
      {
        autoAlpha: 0,
        y: 50,
      },
      {
        scrollTrigger: {
          trigger: trigger ? trigger : item,
          once: true,
          markers: false,
          start: start,
        },
        duration: duration,
        autoAlpha: 1,
        y: 0,
        stagger: { each: stagger },
        delay: delay,
      },
    );
  });
};

// const heroBannerAnimate = () => {

// 	//title and button
// 	animateFadeIn('.hero-banner__content .container')

// 	//background parallax
// 	if (!$('.hero-banner').length) return

// 	let parallaxBg = gsap
// 		.timeline({
// 			scrollTrigger: {
// 				trigger: ".hero-banner",
// 				start: "top top",
// 				end: "bottom top",
// 				scrub: 1
// 				// pin: true
// 				// pinSpacing: false
// 			},
// 			defaults: {
// 				ease: "power1.inOut"
// 			}
// 		})
// 		.fromTo(
// 			".hero-banner",
// 			{ backgroundPosition: "50% 100%"},
// 			{ backgroundPosition: "50% 70%" }
// 		);

// }

const statementPanelAnimate = () => {
  animateFadeIn('.statement-panel__content', { stagger: 0, start: 'center center' }, '.hero-banner__title');
  animateFadeIn('.statement-panel__image', { delay: 0.25, start: 'center center' }, '.hero-banner__title');
};

const servicesAnimate = () => {
  animateFadeIn('.services-selector__row .right-column', { stagger: 0 });
};

const projectAnimate = () => {
  animateFadeIn('.project-mosaic .container', { stagger: 0 });
};

const projectCardAnimate = () => {
  let ele = '.project-card';

  gsap.utils.toArray(ele).forEach((item) => {
    let itemTl = gsap
      .timeline({
        defaults: {
          duration: 0.25,
          ease: 'power1.inOut',
        },
        paused: true,
        onComplete: () => {},
      })
      .fromTo($(item).find('.overlay'), { autoAlpha: 1 }, { autoAlpha: 0 }, 0)
      .fromTo($(item).find('.hover-image'), { opacity: 0 }, { opacity: 1 }, '<')
      .fromTo(
        $(item).find('.project-card__intro'),
        {
          autoAlpha: 0,
          y: -50,
        },
        {
          autoAlpha: 1,
          y: 0,
        },
      )

      .to(
        $(item).find('.project-card__cta'),
        {
          y: 50,
          duration: 0,
        },
        '<',
      );

    $(item)
      .on('mouseenter', function () {
        itemTl.play();
      })
      .on('mouseleave', function () {
        itemTl.reverse();
      });
  });
};

const bankAnimate = () => {
  animateFadeIn('.logo-bank__content', { stagger: 0 });
  animateFadeIn('.logo-bank__logos', { delay: 0.25, stagger: 0.05, duration: 0.5 });
};

const featureImgAnimate = () => {
  animateFadeIn('.feature-image__content .content-wrapper');
  animateFadeIn('.icon-panel__content');
  animateFadeIn('.icon-panel__icons .swiper-wrapper');
};

const buttonHover = () => {
  let ele = '.button';

  gsap.utils.toArray(ele).forEach((item) => {
    if (!$(item).find('.button__arrow').length) return;

    let itemTl = gsap
      .timeline({
        defaults: {
          duration: 0.1,
          ease: 'none',
        },
        paused: true,
        onComplete: () => {},
      })
      .to($(item).find('.button__arrow'), { marginLeft: 15, autoAlpha: 1 }, 0);

    $(item)
      .on('mouseenter', function () {
        itemTl.play();
      })
      .on('mouseleave', function () {
        itemTl.reverse();
      });
  });
};

const animateContainer = () => {
  let ele = '.container';

  gsap.utils.toArray(ele).forEach((item) => {
    const className = ['main-header-container', 'footer-info__container', 'statement-panel__container'];
    const parentClassName = ['footer-top', 'project-mosaic'];
    let hasClass = false;
    let hasParentClass = false;

    className.forEach((className) => {
      if ($(item).hasClass(className)) hasClass = true;
    });

    parentClassName.forEach((parentName) => {
      if ($(item).parent().hasClass(parentName)) hasParentClass = true;
    });

    if (hasClass) return;
    if (hasParentClass) return;

    const options = {
      delay: 0,
      duration: 0.5,
      stagger: 0.2,
    };

    gsap.fromTo(
      $(item).children(),
      {
        autoAlpha: 0,
        y: 50,
      },
      {
        scrollTrigger: {
          trigger: item,
          once: true,
          markers: false,
          start: 'top 90%',
        },
        duration: options.duration,
        autoAlpha: 1,
        y: 0,
        stagger: { each: options.stagger },
        delay: options.delay,
      },
    );
  });
};

const animateCircleFadeIn = (ele, options = {}) => {
  //initiate the defaul values
  const { x = 0, y = 0 } = options;

  //check if element exists, true if it doesn't and stop the function
  if (!$(ele).length) return;

  let circleTl = gsap
    .timeline({
      defaults: {
        duration: 1,
        ease: 'power1.out',
      },
      paused: false,
      onComplete: () => {},
    })
    .fromTo($(ele), { x: x, y: y, opacity: 0 }, { x: 0, y: 0, duration: 1, opacity: 1 });
};

const circleSpin = (ele, degree) => {
  if (!$(ele).length) return;
  gsap.to($(ele), { rotation: `-=${degree}`, duration: 6, repeat: 0, ease: 'linear', transformOrigin: '50% 50%' });
};

$(function () {
  //button
  buttonHover();

  const scrollTrigger = (ele, trigger, ...args) => {
    if (!$(ele).length) return;
    gsap.utils.toArray(ele).forEach((item) => {
      gsap.fromTo(
        $(item),
        {
          autoAlpha: 0,
          ...args[0],
        },
        {
          scrollTrigger: {
            trigger: trigger,
            once: true,
            markers: false,
          },
          duration: 1,
          autoAlpha: 1,
          top: 0,
          left: 0,
        },
      );
    });
  };

  const scrollTriggerSpin = (ele, trigger) => {
    if (!$(ele).length) return;
    ScrollTrigger.create({
      trigger: trigger,
      once: true,
      markers: false,
      onEnter: () =>
        gsap.fromTo(
          $(ele),
          { rotation: `-=0` },
          { rotation: `+=180`, duration: 4, repeat: 0, ease: 'linear', transformOrigin: '50% 50%' },
        ),
    });
  };

  // desktop
  mm.add('(min-width: 1024px)', () => {
    //homepage animation
    // heroBannerAnimate()
    statementPanelAnimate();
    servicesAnimate();
    projectAnimate();
    projectCardAnimate();
    bankAnimate();
    featureImgAnimate();

    //general animation
    animateContainer();

    //hero banner circles
    animateCircleFadeIn('#desktop-green-circle', { x: 180, y: -200 });

    setTimeout(() => {
      circleSpin('#desktop-white-circle', 180);
      circleSpin('.statement-panel .circle', 180);
    }, 700);

    scrollTrigger('.feature-image .circle-green', '.feature-image .heading.h2', { top: -100, left: -200 });
    // circleSpin('.feature-image .circle-gradient')
    scrollTriggerSpin('.feature-image .circle-gradient', '.feature-image .heading.h2');
  });

  mm.add('(max-width: 1349px)', () => {
    gsap.fromTo('.green-circle-mobile', { autoAlpha: 0, translate: '5% -40%' }, { autoAlpha: 1, translate: '1% 1%' });
    circleSpin('.white-circle-mobile-hero', 180);
    scrollTrigger('.green-circle-mobile-feature', '.feature-image .heading.h2', { top: -100, left: -200 });
    // circleSpin('.white-circle-mobile-feature')
    scrollTriggerSpin('.white-circle-mobile-feature', '.feature-image .heading.h2');
  });

  //menu function for home-brighton
  // let tlUp = false;
  // let tlDown = false;
  // let scrollUp;
  // let scrollDown;
  // ScrollTrigger.observe({
  // 	target: window,         // can be any element (selector text is fine)
  // 	type: "wheel,touch",    // comma-delimited list of what to listen for ("wheel,touch,scroll,pointer")
  // 	onUp: () => {

  // 		tlDown = false

  // 		if (scrollUp) clearTimeout(scrollUp)
  // 		if (tlUp) return

  // 		scrollUp = setTimeout(() => {
  // 			console.log('up')
  // 			tlUp = true;
  // 		}, 1000);

  // 	},
  // 	onDown: (self) => {

  // 		console.log('self ', self.scrollY)

  // 		tlUp = false

  // 		if (scrollDown) clearTimeout(scrollDown)
  // 		if (tlDown) return

  // 		scrollDown = setTimeout(() => {
  // 			console.log('down')
  // 			tlDown = true;
  // 		}, 1000);

  // 	},
  // });
});
